import { Link } from 'react-router-dom';

// Small print shown under 3-Day Training payment buttons
export const TermsNote = ({ testId, className = '', dark = false }) => (
  <p data-testid={testId} className={`text-[11px] leading-relaxed ${dark ? 'text-[#9A9A9A]' : 'text-[#5A5A5A]'} ${className}`}>
    By booking, you accept our{' '}
    <Link to="/legal/terms" className="underline hover:text-[#C5A880]">Terms of Sale</Link>.
  </p>
);
